import AtresBarChart from "./atresBarChart";
import AtresPieChart from "./atresPieChart";
export { AtresBarChart, AtresPieChart };